
import './SelectBox.css'
export default function SelectBox({value, onChange, options, label }){

    return <>
        <label className="label">
                {label} *
            </label>
        <select
            value={value}
            onChange={onChange}
            className="selectBox"
        >
            <option className="placeholder" value=" ">Selecione uma empresa</option>
            {options.map((option)=>(
                <option key={option.id} value={option.nome}>
                    {option.nome}
                </option>
            ))}
        </select>
    </>
}